// extracted by mini-css-extract-plugin
module.exports = {"unit":"styles_unit__nNWQy","switches":"styles_switches__3IgBo","unitActions":"styles_unitActions__3ZqaR","onoffInfo":"styles_onoffInfo__19Ie3"};